<script setup lang="ts">
import { PropType, defineProps } from "vue";
import { useUsersStore } from "@/stores/v2";
import AuthService from "@/services/v2/auth";

const userStore = useUsersStore();
defineProps({
  showModal: {
    type: Boolean,
    default: false,
  },
  toggleAbortModal: {
    type: Function as PropType<(payload: MouseEvent) => void>,
    required: true,
  },
});

const handleLogout = () => {
    // Clean store
    userStore.logout();
    // Close session
    AuthService.logout();
}
</script>

<template>
  <div class="flex flex-col items-center p-4 bg-gray-800 text-white h-full">
    <div class="flex flex-col items-center pb-6 gap-2">
      <div class="flex items-center justify-center rounded-full bg-white p-5">
        <svg width="22px" height="22px" viewBox="0 0 12 12" enable-background="new 0 0 12 12" id="layer_1" version="1.1"
          xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g>
            <path
              d="M9.3005371,6.5351563C8.4776001,7.4294434,7.3084106,8,6,8S3.5223999,7.4294434,2.6994629,6.5351563   C1.3145142,7.2350464,0.5,8.6131592,0.5,10.5V12h11v-1.5C11.5,8.6131592,10.6854858,7.2350464,9.3005371,6.5351563z"
              fill="#e3e3e3" />

            <circle cx="6" cy="3.5" fill="#e3e3e3" r="3.5" />
          </g>
        </svg>
      </div>
      <span class="text-lg font-semibold">
        {{ userStore.getCurrentUser?.name }}
      </span>
    </div>
    <ul class="flex flex-col w-full">
      <li @click="toggleAbortModal" class="py-2 cursor-pointer text-primary bg-white px-4 rounded-md transition-colors">
        Dashboard
      </li>
    </ul>
    <!-- Buttons -->
    <div class="flex flex-col w-full mt-auto">
      <button class="py-2 px-4 bg-red-600 hover:bg-red-700 rounded-md transition-colors mb-2">
        Report an Error
      </button>
      <button @click="handleLogout"
        class="py-2 px-4 bg-blue-600 hover:bg-blue-700 rounded-md transition-colors">
        Logout
      </button>
    </div>
  </div>
</template>
